// useRuntimeConfig is not ssr safe
export const useBaseUrl = () => {
  if (process.client) {
    return useRuntimeConfig().public.baseUrl;
  } else {
    return process.env.PUBLIC_BASE_URL;
  }
};
